import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[menuSelectionBackground]',
})
export class MenuSelectionBackgroundDirective {
    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    @HostListener('menuOpened') onMenuOpened() {
        const parentElement = this.elementRef.nativeElement.closest('.row-level');
        if (parentElement == undefined) return;

        this.renderer.addClass(parentElement, 'row-color-menu-active');
    }

    @HostListener('menuClosed') onMenuClosed() {
        const parentElement = this.elementRef.nativeElement.closest('.row-level');
        if (parentElement == undefined) return;

        this.renderer.removeClass(parentElement, 'row-color-menu-active');
    }
}
